import * as S from './styles'
import * as G from '../../theme/global-styles'
import ClientLogo from "../../components/ClientLogo";
import PoweredByQITech from "../../components/PoweredByQITech";
import { CrossCircledIcon } from "@radix-ui/react-icons"
import { useThemeContext } from "../../contexts/ThemeContext";

export const DeactivatedPage  = (props) => {

    const { clientThemeSettings } = useThemeContext();    

    return (
        <G.Container>
            <S.Header>
                <ClientLogo clientThemeSettings={clientThemeSettings} size='small' />
            </S.Header>
            <S.ExpiredContainer>
                <CrossCircledIcon color="red" width={32} height={32} />
                <G.Title>Assinatura removida</G.Title>
                <S.Description>Você foi removido da lista de assinantes. Não precisa mais seguir com o processo de assinatura.</S.Description>
            </S.ExpiredContainer>
            <S.Footer>
                <PoweredByQITech />
            </S.Footer>
        </G.Container>
    )
}